import React, { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import Dialog from 'components/shared/Dialog';
import Button from 'components/shared/Button';
import Typo from 'components/shared/Typo';
import Form from 'components/shared/Form';

const defaultValues = {
  label: '',
  value: 0
};

function DeviceChartMarkerDialog({ open, marker, onCancel, onSubmit }) {
  const methods = useForm({
    defaultValues,
    values: marker && {
      label: marker.label,
      value: marker.value
    }
  });
  const { reset, register } = methods;
  const handleReset = useCallback(
    (event) => {
      event.preventDefault();
      reset();
      onCancel(marker);
    },
    [reset, onCancel, marker]
  );
  const handleSubmit = useCallback(
    (values) => {
      onSubmit({ ...marker, ...values });
    },
    [onSubmit, marker]
  );

  return (
    <Dialog open={open}>
      <Dialog.Container as={Form} maxWidth={488} methods={methods} onSubmit={handleSubmit}>
        <Dialog.Title>
          <Typo as="h3" variant="heading5">
            Save Marker
          </Typo>
        </Dialog.Title>
        <Dialog.Content>
          <input type="text" autoComplete="off" {...register('label', { required: true })} />
        </Dialog.Content>
        <Dialog.Actions>
          <Button type="reset" variant="text" color="primary" size="medium" onClick={handleReset}>
            Cancel
          </Button>
          <Button type="submit" variant="contained" color="primary" size="medium">
            Save
          </Button>
        </Dialog.Actions>
      </Dialog.Container>
    </Dialog>
  );
}

export { DeviceChartMarkerDialog };
